import { PublicCallback } from 'globals/types';
import * as AssistantAPI from 'core_main/api/assistant';
import { InitAssistantParameters } from 'core_main/api/assistant/types';
import { createInitAssistantCallbackResponse } from './helpers';

export const initAssistant = (
  params: InitAssistantParameters,
  cb?: PublicCallback,
) => {
  return AssistantAPI.initAssistant(params)
    .then((res) => {
      if (typeof cb === 'function') {
        const callbackResponse = createInitAssistantCallbackResponse(res.data);
        cb(callbackResponse);
      }
    })
    .catch((error) => {
      if (typeof cb === 'function') cb(null, error);
      console.error('Failed to init assistant', error);
    });
};
